import { styled } from '@mui/system';
import { Button } from '@mui/material';

export const ButtonsContainer = styled('div')(() => ({
  backgroundColor: 'white',
  height: '72px',
  left: 0,
  right: 0,
  width: '100%',
  bottom: 0,
  zIndex: '10',
  position: 'fixed',
  display: 'flex'
}));

export const ButtonWrapper = styled('div')(() => ({
  flex: 1,
  height: '100%',
  overflow: 'auto'
}));

const FixedButton = styled(Button)(() => ({
  height: '100%',
  width: '100%',
  borderRadius: 0
}));

export const LightTextButton = styled(FixedButton)(() => ({
  color: 'white'
}));

export const LeftButtonWrapper = styled(ButtonWrapper)(() => ({
  borderRight: '0.5px solid white'
}));

export const LeftButton = styled(FixedButton)(() => ({
  borderRight: '0.5px solid white'
}));
